import { CMSAdvancedShellFlowZone } from "@/pages/cms/advanced/shell-flow-zone";

export default function CMSAdvancedEnTete() {
  return <CMSAdvancedShellFlowZone step="HEADER" />;
}
